import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { KnownCategories } from '../../viewmodels/AppViewModels';
import { reactQueryClient } from '../../web/ReactQueryProvider';

export const SOCIAL_CAMPAIGN_CATEGORIES_QUERY_KEY = 'socialCampaignCategories';

export function useSocialCategories(params: {
	industry: Api.Industry;
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
	select?: (categories: string[]) => string[];
	withDrafts?: boolean;
}) {
	const userSession = useUserSession();
	return useQuery({
		enabled: params.enabled,
		queryFn: async () => {
			const categories = await userSession.webServiceHelper.callAsync<string[]>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `template/${encodeURIComponent(params.industry)}/socialCategories`,
					impersonationContext: params.impersonationContext,
				}),
				'GET'
			);

			if (params.withDrafts) {
				// Insert SocialMediaDrafts at index 2 to place it after "All" and "My Templates" categories
				categories.splice(2, 0, KnownCategories.SocialMediaDrafts);
			}

			return categories;
		},
		queryKey: [SOCIAL_CAMPAIGN_CATEGORIES_QUERY_KEY, params.industry, params.impersonationContext],
		select: params.select,
		refetchOnWindowFocus: false,
	});
}
export const invalidateSocialCategoryTemplates = () => {
	reactQueryClient.invalidateQueries({ queryKey: [SOCIAL_CAMPAIGN_CATEGORIES_QUERY_KEY] });
};
